const GET_QUIZ_CARD_REQUEST = "GET_QUIZ_CARD_REQUEST";
const GET_QUIZ_CARD_COMPLETED = "GET_QUIZ_CARD_COMPLETED";
const GET_QUIZ_CARD_ERROR = "GET_QUIZ_CARD_ERROR";

const GET_QUIZ_SYSTEM_INFO_REQUEST = "GET_QUIZ_SYSTEM_INFO_REQUEST";
const GET_QUIZ_SYSTEM_INFO_COMPLETED = "GET_QUIZ_SYSTEM_INFO_COMPLETED";
const GET_QUIZ_SYSTEM_INFO_ERROR = "GET_QUIZ_SYSTEM_INFO_ERROR";

const GET_QUIZ_MAIN_REQUEST = "GET_QUIZ_MAIN_REQUEST";
const GET_QUIZ_MAIN_COMPLETED = "GET_QUIZ_MAIN_COMPLETED";
const GET_QUIZ_MAIN_ERROR = "GET_QUIZ_MAIN_ERROR";

const UPDATE_QUIZ_MAIN_REQUEST = "UPDATE_QUIZ_MAIN_REQUEST";
const UPDATE_QUIZ_MAIN_COMPLETED = "UPDATE_QUIZ_MAIN_COMPLETED";
const UPDATE_QUIZ_MAIN_ERROR = "UPDATE_QUIZ_MAIN_ERROR";

const GET_QUESTION_LIST_REQUEST = "GET_QUESTION_LIST_REQUEST";
const GET_QUESTION_LIST_COMPLETED = "GET_QUESTION_LIST_COMPLETED";
const GET_QUESTION_LIST_ERROR = "GET_QUESTION_LIST_ERROR";

const UPDATE_QUIZ_LOGO_REQUEST = "UPDATE_QUIZ_LOGO_REQUEST";
const UPDATE_QUIZ_LOGO_COMPLETED = "UPDATE_QUIZ_LOGO_COMPLETED";
const UPDATE_QUIZ_LOGO_ERROR = "UPDATE_QUIZ_LOGO_ERROR";

const DELETE_QUIZ_LOGO_REQUEST = "DELETE_QUIZ_LOGO_REQUEST";
const DELETE_QUIZ_LOGO_COMPLETED = "DELETE_QUIZ_LOGO_COMPLETED";
const DELETE_QUIZ_LOGO_ERROR = "DELETE_QUIZ_LOGO_ERROR";

export default {
  GET_QUIZ_CARD_REQUEST,
  GET_QUIZ_CARD_COMPLETED,
  GET_QUIZ_CARD_ERROR,
  GET_QUIZ_SYSTEM_INFO_REQUEST,
  GET_QUIZ_SYSTEM_INFO_COMPLETED,
  GET_QUIZ_SYSTEM_INFO_ERROR,
  GET_QUIZ_MAIN_REQUEST,
  GET_QUIZ_MAIN_COMPLETED,
  GET_QUIZ_MAIN_ERROR,

  UPDATE_QUIZ_MAIN_REQUEST,
  UPDATE_QUIZ_MAIN_COMPLETED,
  UPDATE_QUIZ_MAIN_ERROR,

  GET_QUESTION_LIST_REQUEST,
  GET_QUESTION_LIST_COMPLETED,
  GET_QUESTION_LIST_ERROR,

  UPDATE_QUIZ_LOGO_REQUEST,
  UPDATE_QUIZ_LOGO_COMPLETED,
  UPDATE_QUIZ_LOGO_ERROR,

  DELETE_QUIZ_LOGO_REQUEST,
  DELETE_QUIZ_LOGO_COMPLETED,
  DELETE_QUIZ_LOGO_ERROR,
}
